// src/pages/StudentPortal/ZoomLessonPage.js
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const ZoomLessonPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const attendeeLink = new URLSearchParams(location.search).get('link');

  if (!attendeeLink) {
    return (
      <Box p={4}>
        <Typography variant="h6" color="error">No Zoom link provided.</Typography>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>Go Back</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', width: '100vw', backgroundColor: '#f0f0f0' }}>
      <iframe
        src={attendeeLink}
        title="Zoom Lesson"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        allow="camera; microphone; fullscreen"
      ></iframe>
    </Box>
  );
};

export default ZoomLessonPage;
